import { ThemeOptions } from "@mui/material/styles";

export const customTheme: ThemeOptions = {
  palette: {
    // mode: "dark", // Changed from mode to mode in v5
    primary: {
      main: "#0B3C5D",
    },
    secondary: {
      main: "#72CA00",
      contrastText: "white",
    },
  },
  typography: {
    fontFamily: '"Inter", "Arial", sans-serif',
    fontSize: 12,
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 800,
    button: { textTransform: "none" },
  },
  components: {
    // Migrated from overrides to components in v5
    MuiButton: {
      styleOverrides: {
        containedSecondary: { color: "white" },
      },
    },
    // Note: MuiDataGrid is from "@mui/x-data-grid, not @mui/material
    // DataGrid styling should be done via sx prop or styled components
    // The columnHeaderWrapper styling is handled in CommonXGrid/styles.tsx
  },
};
